
export default function Products() {
  const products = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Medical Oxygen',
      purity: '99.5%+',
      grade: 'Medical',
      description:
        'USP-grade medical oxygen for healthcare facilities, respiratory therapy, and emergency services. FDA compliant.',
      color: 'from-teal-500 to-cyan-500',
      bg: 'from-stone-50 to-teal-50',
      border: 'border-teal-200',
    },
    {
      icon: 'ri-test-tube-line',
      title: 'Industrial Nitrogen',
      purity: '99.999%',
      grade: 'Industrial',
      description:
        'High-purity nitrogen for inerting, blanketing, and purging. Ideal for food packaging and electronics.',
      color: 'from-cyan-500 to-teal-500',
      bg: 'from-stone-50 to-cyan-50',
      border: 'border-cyan-200',
    },
    {
      icon: 'ri-bubble-chart-line',
      title: 'Specialty Mixtures',
      purity: 'Custom',
      grade: 'Medical & Industrial',
      description:
        'Custom-blended gas mixtures engineered to exact specifications. Calibration gases and welding mixtures.',
      color: 'from-amber-500 to-orange-500',
      bg: 'from-stone-50 to-amber-50',
      border: 'border-amber-200',
    },
    {
      icon: 'ri-fire-line',
      title: 'Argon Gas',
      purity: '99.998%',
      grade: 'Industrial',
      description:
        'Ultra-high purity argon for welding, metal fabrication, and semiconductor manufacturing.',
      color: 'from-teal-500 to-cyan-500',
      bg: 'from-stone-50 to-teal-50',
      border: 'border-teal-200',
    },
    {
      icon: 'ri-contrast-drop-line',
      title: 'Carbon Dioxide',
      purity: '99.9%',
      grade: 'Medical & Industrial',
      description:
        'Food-grade and industrial CO2 for beverage carbonation, welding, and pH control.',
      color: 'from-emerald-500 to-teal-500',
      bg: 'from-stone-50 to-emerald-50',
      border: 'border-emerald-200',
    },
    {
      icon: 'ri-dashboard-3-line',
      title: 'Calibration Gases',
      purity: 'NIST Traceable',
      grade: 'Research',
      description:
        'Certified reference standards for instrument calibration with complete certificates of analysis.',
      color: 'from-cyan-500 to-teal-500',
      bg: 'from-stone-50 to-cyan-50',
      border: 'border-cyan-200',
    },
  ];

  return (
    <section id="products" className="bg-gradient-to-b from-stone-100 to-stone-200 py-24 px-12">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-10 h-1 bg-gradient-to-r from-transparent to-teal-500 rounded-full"></div>
            <span className="text-teal-600 text-sm font-bold tracking-wide uppercase">
              Our Products
            </span>
            <div className="w-10 h-1 bg-gradient-to-r from-teal-500 to-transparent rounded-full"></div>
          </div>
          <h2 className="text-stone-800 font-black text-4xl mb-4">
            Medical &amp; Industrial{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-cyan-500">
              Gas Portfolio
            </span>
          </h2>
          <p className="text-stone-600 text-base max-w-2xl mx-auto">
            From FDA-compliant medical-grade oxygen to ultra-high purity industrial
            gases, we deliver precision solutions for every critical application.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-3 gap-6" data-product-shop>
          {products.map((product, index) => (
            <div
              key={index}
              className={`group relative bg-gradient-to-br ${product.bg} ${product.border} border rounded-2xl p-6 hover:shadow-xl transition-all duration-300 cursor-pointer overflow-hidden`}
            >
              {/* Icon */}
              <div className={`w-14 h-14 bg-gradient-to-br ${product.color} rounded-xl flex items-center justify-center mb-5 shadow-lg`}>
                <i className={`${product.icon} text-2xl text-white`}></i>
              </div>

              {/* Badges */}
              <div className="flex items-center gap-2 mb-4">
                <span className={`bg-gradient-to-r ${product.color} text-white rounded-full px-3 py-1 text-xs font-bold`}>
                  {product.purity}
                </span>
                <span className="bg-stone-100 border border-stone-300 rounded-full px-3 py-1 text-stone-600 text-xs font-semibold shadow-sm">
                  {product.grade}
                </span>
              </div>

              {/* Title */}
              <h3 className="text-stone-800 font-bold text-lg mb-2">{product.title}</h3>

              {/* Description */}
              <p className="text-stone-500 text-sm leading-relaxed">{product.description}</p>

              {/* Arrow */}
              <div className="mt-5 flex items-center gap-2 text-teal-600 opacity-0 group-hover:opacity-100 transition-opacity">
                <span className="text-sm font-semibold">Learn More</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
